import React, { useContext } from 'react'

import { Controller, useFormContext } from 'react-hook-form'
import { Grid } from '@material-ui/core'

import ClearTextField from 'artkive/components/Forms/ClearTextField'
import { TrackerContext } from 'artkive/components/Tracker'
import useMobileBreakpoint from 'artkive/hooks/useMobileBreakpoint'
import validations from 'artkive/utils/validations'

import SectionGrid from '../SectionGrid'

const PersonalNameFragment = () => {
  const isMobile = useMobileBreakpoint()
  const {
    formState: { errors },
  } = useFormContext()
  const { fire } = useContext(TrackerContext)
  const inputMargin = isMobile ? 'dense' : undefined

  return (
    <SectionGrid>
      <Grid item xs={12} md={6}>
        <Controller
          name='firstName'
          defaultValue=''
          rules={validations.firstName}
          render={({ field }) => (
            <ClearTextField
              error={!!errors.firstName}
              helperText={errors.firstName?.message}
              margin={inputMargin}
              fullWidth
              label='First Name'
              type='text'
              variant='outlined'
              {...field}
              onBlur={(e) => {
                field.onBlur(e)
                fire('blur')
              }}
              autoComplete='given-name'
            />
          )}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Controller
          name='lastName'
          defaultValue=''
          rules={validations.lastName}
          render={({ field }) => (
            <ClearTextField
              error={!!errors.lastName}
              helperText={errors.lastName?.message}
              margin={inputMargin}
              fullWidth
              label='Last Name'
              type='text'
              variant='outlined'
              {...field}
              onBlur={(e) => {
                field.onBlur(e)
                fire('blur')
              }}
              autoComplete='family-name'
            />
          )}
        />
      </Grid>
    </SectionGrid>
  )
}

export default PersonalNameFragment
